import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { IConfirmDeleteInspectionDialogProps } from './confirm-delete-inspection-dialog.interface';

const ConfirmDeleteInspectionDialog = (props: IConfirmDeleteInspectionDialogProps) => {
  const {
    open,
    handleClose,
    deleteInspectionAction,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid="delete-dialog"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontFamily: "'Poppins' !important" }}>
        {"Confirmar exclusão"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          data-testid="alert-dialog-description"
          sx={{ fontFamily: "'Poppins' !important" }}
        >
          As fotos desta vistoria serão apagadas, deseja continuar a exclusão?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className='secondary-button'
          onClick={handleClose}
          data-testid="back-button"
        >Voltar</Button>
        <Button  
          className='primary-button' 
          onClick={deleteInspectionAction}  
          autoFocus
          data-testid="remove-button"
        >
          Remover Vistoria
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteInspectionDialog;
